import { memo, type ReactNode } from 'react';

import { type Board } from '@air/api/types';

import {
  DNDMovableToBoardItem,
  type DNDMovableToBoardItemProps,
} from '~/components/Shared/Drag/DNDMovableToBoardItem/DNDMovableToBoardItem';
import dragTypes from '~/components/Shared/Drag/dragTypes';

export type DragDroppableBoardShellProps = {
  board: Board;
  children?: ReactNode;
  index?: number;
} & Pick<DNDMovableToBoardItemProps, 'onDragStart' | 'enabled'>;

export const DraggableBoardCard = memo(({ board, children, index, ...rest }: DragDroppableBoardShellProps) => (
  <DNDMovableToBoardItem
    id={board.id}
    item={{
      type: dragTypes.boardCard,
      board,
      index,
    }}
    index={index}
    {...rest}
  >
    <>{children}</>
  </DNDMovableToBoardItem>
));

DraggableBoardCard.displayName = 'DraggableBoardCard';
